import styled from 'styled-components';

export const RefreshSVGButton = styled.svg`
font-size: 13pt;
cursor: pointer;
 &:hover {
    path {
    stroke: var(--secondary);
    }
}
padding-right: 10px;
`;
